<template>
  <div class="modal fade" id="mod-add-posting" role="dialog">
    <div
      class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
    >
      <div
        class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
      >
        <div class="modal-header- flex items-start justify-between p-0 m-0">
          <h4
            class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
          >
            New Account Posting
          </h4>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
            @click="cancel"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="m-0 p-0">
          <div class="pb-[16px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >Customer</label
            >
            <div>
              <select
                class="bg-transparent border-[1.5px] border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': $v.posting.customerId.$error }]"
                placeholder="Select a customer"
                v-model.trim="$v.posting.customerId.$model"
              >
                <option v-for="c in customers" :key="c.id" :value="c.id">
                  {{ c.text }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.posting.customerId.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >Posting Type</label
            >
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': $v.posting.paymentType.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.posting.paymentType.$model"
              >
                <option value=""></option>
                <option
                  v-for="option in paymentItem"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.name }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.posting.paymentType.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div v-if="posting.paymentType === 0" class="pb-[16px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >Payment Channel</label
            >
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': $v.posting.paymentChannelId.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.posting.paymentChannelId.$model"
              >
                <option
                  v-for="br in paymentChannels"
                  :key="br.id"
                  :value="br.id"
                >
                  {{ prepareDetail(br) }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.posting.paymentChannelId.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-medium text-[14px] leading-[20px]"
            >
              Enter Amount</label
            >
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': $v.posting.amount.$error }]"
                type="number"
                placeholder="Enter Amount"
                v-model.trim="$v.posting.amount.$model"
              />
              <div class="invalid-feedback" v-if="!$v.posting.amount.required">
                Field is required.
              </div>
            </div>
          </div>
          <div v-if="posting.paymentType !== 0" class="pb-[16px]">
            <label
              class="text=[#353535] font-medium text-[14px] leading-[20px]"
            >
              Enter Note</label
            >
            <div>
              <textarea
                :class="[{ 'is-invalid': $v.posting.paymentNotes.$error }]"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                type="text"
                placeholder="Enter Note"
                autocomplete="off"
                v-model.trim="$v.posting.paymentNotes.$model"
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="
                  posting.paymentType !== 0 && !$v.posting.paymentNotes.required
                "
              >
                Field is required.
              </div>
            </div>
          </div>
          <div>
            <label
              class="text=[#353535] font-medium text-[14px] leading-[20px]"
            >
              Posting Date</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.posting.postingDate.$error }]"
                type="date"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :max="maxDate"
                placeholder="Enter payment date"
                v-model.trim="$v.posting.postingDate.$model"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.posting.postingDate.required"
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
        <div class="w-full flex items-center gap-[5px] mt-[24px]">
          <button
            class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            @click="cancel"
          >
            Cancel
          </button>
          <button
            :disabled="isPosting"
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            @click.prevent="create"
          >
            <span
              v-if="isPosting"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <i class="sr-only">Loading...</i>
            </span>
            <span v-else>Post</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import datePicker from "vue-bootstrap-datetimepicker";
import { helper } from "@/helper";

export default {
  components: { datePicker },

  data() {
    return {
      posting: {
        customerId: "",
        paymentType: "",
        amount: 0,
        paymentNotes: "",
        postingDate: "",
        paymentChannelId: "",
      },

      paymentItem: [
        {
          name: "Payment",
          value: 0,
        },
        {
          name: "Credit Note",
          value: 1,
        },
        {
          name: "Debit Note",
          value: 2,
        },
      ],

      customers: [],
      paymentChannels: [],
      isPosting: false,
      maxDate: "",
    };
  },

  validations() {
    let posting = {
      paymentType: { required },
      amount: { required },
      postingDate: { required },
      customerId: { required },
      postingDate: { required },
    };

    if (this.posting.paymentType === 0)
      posting = { ...posting, paymentChannelId: { required } };
    else posting = { ...posting, paymentNotes: { required } };

    return { posting };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },

  async created() {
    await this.getCustomers();
    await this.getPaymentChannels();
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },

  methods: {
    async create() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isPosting = true;
        const data = {
          ...this.posting,
        };
        try {
          const response = await this.$http.post("/AccountPosting", data);
          if (response.ok) {
            this.$toast.success("Posted to account succesfully", {
              icon: true,
              rtl: false,
            });
            this.reset();
            this.$emit("onPostAccountComplete");
          }
        } catch (error) {}
        this.isPosting = false;
      }
    },

    async getCustomers() {
      try {
        const response = await this.$http.get(
          "/Users/getItemListOfCustomers/" + this.user.parentId
        );

        if (response.ok) {
          this.customers = response.body;
        }
      } catch (error) {}
    },

    async getPaymentChannels() {
      try {
        const response = await this.$http.get(
          "/PaymentChannels/getListNoPaging?active=true" +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        );

        if (response.ok) this.paymentChannels = response.body;
      } catch (error) {}
    },

    prepareDetail(value) {
      const name = value.paymentChannelTypeName;
      let result = "";
      if (name) {
        result += name;

        if (name.toLowerCase() === "bank") {
          result += "/ " + value.bankName + "/ " + value.accountNumber;
        } else if (name.toLowerCase() === "pos") {
          result += "/ " + value.bankName + "/ " + value.terminalId;
        } else if (name.toLowerCase() === "cryptocurrency") {
          result += "/ " + value.bankName + "/ " + value.walletAddress;
        }
      }
      return result;
    },

    cancel() {
      this.reset();
      this.$emit("onPostAccountCancel");
    },

    reset() {
      this.posting = {
        paymentType: "",
        amount: 0,
        paymentNotes: "",
        postingDate: "",
        paymentChannelId: "",
        customerId: "",
      };

      setTimeout(() => {
        this.$v.$reset();
      }, 0);
    },
  },
};
</script>
